import { render, staticRenderFns } from "./multi-tag-input.vue?vue&type=template&id=12b03b5e&scoped=true&"
import script from "./multi-tag-input.vue?vue&type=script&lang=js&"
export * from "./multi-tag-input.vue?vue&type=script&lang=js&"
import style0 from "./multi-tag-input.vue?vue&type=style&index=0&id=12b03b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b03b5e",
  null
  
)

export default component.exports